"use client";

import { useState } from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
const services = [{
  id: "g2g-delegations",
  title: "G2G Trade Delegations",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/g2g-delegation.png",
  link: "/TradeServicesPage"
}, {
  id: "b2b-matchmaking",
  title: "B2B Strategic Matchmaking",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/b2b-matchmaking.png",
  link: "/TradeServicesPage"
}, {
  id: "investment-roadshows",
  title: "Investment Roadshows",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/investment-roadshow.png",
  link: "/MarketEntryPage"
}, {
  id: "sector-forums",
  title: "Sector-Specific Forums",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/sector-forums.png",
  link: "/TradeServicesPage"
}, {
  id: "sovereign-access",
  title: "Sovereign Fund Access",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/sovereign-wealth.png",
  link: "/MarketEntryPage"
}];
export default function DetailedServiceLinks() {
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="83880" id="trade-delegation-investment-introductions" className="bg-background py-24 lg:py-32 overflow-hidden text-foreground">
      <div ref={ref} className={`max-w-[1280px] mx-auto px-6 lg:px-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex flex-col-reverse lg:flex-row gap-12 lg:gap-24 items-center">
          
          {/* Text Content Column */}
          <div className="w-full lg:w-1/2 flex flex-col justify-center">
            <div className="flex flex-col gap-8 lg:gap-12">
              {services.map((service, i) => {
              const isActive = activeIndex === i;
              return <div key={service.id} data-index={i} onMouseEnter={() => setActiveIndex(i)} onClick={() => setActiveIndex(i)} className="group relative flex items-center">
                    <Link to={service.link} className="flex items-center justify-between w-full py-4 border-b border-border/40 hover:border-secondary/50 transition-colors duration-300">
                      <h2 className={`font-serif text-[36px] leading-tight transition-colors duration-300 ${isActive ? "text-primary" : "text-foreground/60 group-hover:text-primary/80"}`}>
                        {service.title}
                      </h2>
                      <ArrowRight className={`size-8 transition-all duration-300 ${isActive ? "text-secondary opacity-100 translate-x-0" : "text-foreground/30 opacity-0 -translate-x-4 group-hover:opacity-50 group-hover:translate-x-0"}`} />
                    </Link>
                  </div>;
            })}
            </div>
          </div>

          {/* Image Display Column */}
          <div className="w-full lg:w-1/2">
            <div className="relative w-full aspect-[4/3] lg:aspect-[4/5] rounded-2xl overflow-hidden bg-muted shadow-xl shadow-shadow-color/5">
              {services.map((service, i) => <img key={service.id} data-index={i} src={service.image} alt={service.title} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[400ms] ease-in-out ${activeIndex === i ? "opacity-100 z-10" : "opacity-0 z-0"}`} />)}
              
              {/* Overlay Gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent z-20 pointer-events-none" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}